import {getCalendarLinks} from '../../../../selectors/calendar-links'
import {DetailsPageAppProps} from '../../../app/interfaces'
import {connect} from '../../../runtime-context/context'
import {SuccessActionsOwnProps, SuccessActionsRuntimeProps} from './interfaces'
import {SuccessActions as Presentation} from './success-actions'

const mapRuntime = ({
  actions: {addToCalendarClicked, addToCalendarOptionClicked},
  state,
}: DetailsPageAppProps): SuccessActionsRuntimeProps => ({
  calendarLinks: getCalendarLinks(state),
  addToCalendarClicked,
  addToCalendarOptionClicked,
})

export const SuccessActions = connect<SuccessActionsOwnProps, SuccessActionsRuntimeProps>(mapRuntime)(Presentation)
